// import { Uid } from "./Uid";
import { User } from "./User";
import { Util } from "../services/Utils/Util";

export class RoomInvite {
  static COL = 'roominvites';
  id: string;
  created = new Date();
  generatedByAPI?: boolean;
  password: string = '';
  expireDate?: Date = undefined;
  roomName?: string;
  roomImageUrl?: string | null = null;
  roomDescription?: string;
  roomUserImages?: string[] = [];

  constructor(public roomId: string, public creator: User) {
    this.id = uuid();
  }

  // static getID(roomId: string, userId: string) {
  //   return `${roomId.substr(0, 15)}_${userId}`;
  // }

  static getUrl(inviteId: string) {
    const appUrl = Util.getAppUrl();
    return `${appUrl}/invitation/${inviteId}`;
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}